export const validatePrimaryPayer = (value: string): Promise<void> => {
  if (!value) {
    return Promise.resolve();
  }

  const downcaseValue = value.toLowerCase().trim();

  const federallyFundedKeywords = [
    'medicare',
    'medicaid',
    'medigap',
    'veterans affairs',
    'department of veterans affairs',
    'tricare',
    'champva',
    'champus',
    'triwest',
    'military health',
    'military insurance',
    'federal employee program',
    'cms',
    'indian health service',
    'ihs',
    'public health plan',
    'federal-funded',
    'state-funded',
    'government insurance',
    'state health plan',
  ];

  const hasBlockedKeyword = federallyFundedKeywords.some((keyword) =>
    downcaseValue.includes(keyword)
  );

  const regexBlockedPatterns = [/\bva\b/i, /\bdod\b/i];

  const hasBlockedPattern = regexBlockedPatterns.some((pattern) => pattern.test(downcaseValue));

  if (hasBlockedKeyword || hasBlockedPattern) {
    return Promise.reject(
      new Error(
        'Patients are ineligible for copay assistance if they participate in Medicare, Medicaid, Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or state-funded programs.'
      )
    );
  }

  return Promise.resolve();
};
